import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, tap } from 'rxjs';
import { environment } from 'environments/environment';
import { AuthService } from '@core/auth/auth.service';
import { NavigationService } from '@core/navigation/navigation.service';

@Injectable({
    providedIn: 'root'
})
export class NavigationMenuService {
    private menuData: any = null;

    constructor(private httpClient: HttpClient, private _authService: AuthService/* , private _navigationService: NavigationService */) { }

    get getMenu() {
        return this.menuData;
    }

    set setMenu(menu){
        this.menuData = menu;
    }

    getMenuData(): Observable<any> {
        if (!this.menuData) {
            // Llamar al servicio de menú para obtener los datos
            return this.fetchMenuData();
        } else {
            // Devolver los datos almacenados en memoria
            return new Observable(observer => {
                observer.next(this.menuData);
                observer.complete();
            });
        }
    }

    private fetchMenuData(): Observable<any> {
        const token = 'YOUR_TOKEN_HERE'; // Obtener el token de donde corresponda

        const headers = new HttpHeaders().set('Authorization', `Bearer ${this._authService.accessToken}`);

        return this.httpClient.post<any>(`${environment.menu}`, null, { headers }).pipe(
            tap((data) => {
                this.menuData = data;
                // this._navigationService._navigationMenuData = this.menuData;
            })
        );
    }
}
